module.exports = __webpack_public_path__ + "static/media/Rubik-Bold.b5b2632a.ttf";